import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faArrowDown,
  faArrowUp,
  faCaretDown,
  faCaretUp,
} from '@fortawesome/free-solid-svg-icons'
import { useDispatch } from 'react-redux'
import { useEffect, useRef } from 'react'

//the functions being dispatched in this file are passed by parent props {..libraryActions}

const ReoderItems = (props) => {
  let language = props.language || {}
  const dispatch = useDispatch()

  const reorderRef = useRef()

  useEffect(() => {
    const handleReorderClick = (e) => {
      const clickedElement = e.target
      const isReorderButton = clickedElement.closest('.reorder-button')

      if (
        reorderRef.current &&
        props.library.showLibraryReorder &&
        !reorderRef.current.contains(clickedElement) &&
        !isReorderButton
      ) {
        dispatch(props.toggleLibraryOrder())
      }
    }

    document.addEventListener('click', handleReorderClick, true)

    return () => {
      document.removeEventListener('click', handleReorderClick, true)
    }
  }, [props.library.showLibraryReorder, dispatch, props])

  return (
    <div ref={reorderRef} className='reorder-items-wrapper'>
      <div>
        <p>Reorder Library</p>
      </div>
      <div className='scrollbar reorder-items-list'>
        {props.library.files.map((item, index) => {
          return (
            <div key={item.id}>
              {(() => {
                return (
                  <div>
                    <div
                      onClick={() => {
                        dispatch(props.setItemIndex(index))
                      }}
                      className={`category-name-wrapper${
                        props.itemIndex === index ? ' selected' : ''
                      }`}
                    >
                      <h2 className='category-name'>{item.name}</h2>
                    </div>
                  </div>
                )
              })()}
            </div>
          )
        })}
      </div>

      {(() => {
        switch (true) {
          case props.courseIndex === null:
            return (
              <div className='reorder-btn-wrapper'>
                <button
                  onClick={() =>
                    props.itemIndex > 0
                      ? dispatch(props.reorderItems(props.itemIndex - 1))
                      : null
                  }
                  title='Bring item up'
                  className='btn course-reorder-btn reorder-btn-up'
                >
                  <FontAwesomeIcon icon={faCaretUp} />
                </button>
                <button
                  onClick={() =>
                    props.itemIndex < props.library.files.length - 1
                      ? dispatch(props.reorderItems(props.itemIndex + 1))
                      : null
                  }
                  title='Bring item down'
                  className='btn btn-transparent border'
                >
                  <FontAwesomeIcon icon={faArrowDown} />
                </button>
              </div>
            )
          case props.itemIndex === null:
            let items = []

            Object.keys(props.library.files).map(
              (fileItem) => (items = [...items, ...fileItem])
            )

            return (
              <div className='reorder-btn-wrapper'>
                <button
                  onClick={() =>
                    props.itemIndex > 0
                      ? dispatch(props.reorderItems(props.itemIndex - 1))
                      : null
                  }
                  style={{ padding: '2px 10px' }}
                  title='Bring item up'
                  className='btn btn-white border'
                >
                  <FontAwesomeIcon icon={faArrowUp} />
                </button>
                <button
                  onClick={() =>
                    props.itemIndex < props.library.files.length - 1
                      ? dispatch(props.reorderItems(props.itemIndex + 1))
                      : null
                  }
                  style={{ padding: '2px 10px' }}
                  title='Bring item down'
                  className='btn btn-white border'
                >
                  <FontAwesomeIcon icon={faCaretDown} />
                </button>
              </div>
            )
          default:
            return (
              <div className='reorder-btn-wrapper'>
                <button
                  onClick={() =>
                    props.itemIndex > 0
                      ? dispatch(props.reorderItems(props.itemIndex - 1))
                      : null
                  }
                  style={{ padding: '2px 10px' }}
                  title='Bring item up'
                  className='btn btn-white border'
                >
                  <FontAwesomeIcon icon={faArrowUp} />
                </button>
                <button
                  onClick={() =>
                    props.itemIndex < props.library.files.length - 1
                      ? dispatch(props.reorderItems(props.itemIndex + 1))
                      : null
                  }
                  style={{ padding: '2px 10px' }}
                  title='Bring item down'
                  className='btn btn-white border'
                >
                  <FontAwesomeIcon icon={faArrowDown} />
                </button>
              </div>
            )
        }
      })()}
      <div className='reorder-action-btn' style={{ textAlign: 'left' }}>
        <button
          onClick={() => dispatch(props.saveLibraryOrder())}
          className='btn btn-info px-3 py-2'
        >
          {language.general ? language.general.save : null}
        </button>
        <button
          onClick={() => dispatch(props.toggleLibraryOrder())}
          className='btn btn-transparent px-3 py-2'
        >
          {language.general ? language.general.cancel : null}
        </button>
      </div>
    </div>
  )
}

export default ReoderItems
